import PageLayout from './PageLayout';
import { Timeline } from '@/components/wedding';

const SchedulePage = () => (
  <PageLayout testId="schedule-page">
    <Timeline />
  </PageLayout>
);

export default SchedulePage;
